import React from "react";

const ContextLoader = ({ cardCount = 4 }) => {
  return (
    <div className="item_loader">
      <div className="item_loader_header_context fade-in" />
      <div className="item_loader_fitler fade-in" />

      <div className="item_loader_body_context">
        {Array.from({ length: cardCount }).map((_, index) => (
          <div key={index} className="item_loader_card_context fade-in" />
        ))}
      </div>
    </div>
  );
};

export default ContextLoader;